// @Foundations
import { AlphaFoundationsThemes } from '../../commons/alpha-foundations.themes';
import { BordersFoundationsThemes } from '../../commons/borders-foundations.themes';
import { BlurFoundationsThemes } from '../../commons/blur-foundations.themes';
import { FontsLineHeightsFoundationsThemes } from '../../commons/fonts-line-heights-foundations.themes';
import { FontsExceptionsFoundationsThemes } from '../../commons/fonts-exceptions-foundations.themes';
import { FontsFamiliesFoundationsThemes } from '../../commons/fonts-families-foundations.themes';
import { FontsSizesFoundationsThemes } from '../../commons/fonts-sizes-foundations.themes';
import { FontsWeightFoundationsThemes } from '../../commons/fonts-weight-foundations.themes';
import { FoundationsKubitCobrandedRegularBlursTheming } from './foundations-kubit-cobranded-regular-blurs.theming';
import { FoundationsKubitCobrandedRegularFontsHeadingsTheming } from './foundations-kubit-cobranded-regular-fonts-headings.theming';
import { FoundationsKubitCobrandedRegularFontsOthersTheming } from './foundations-kubit-cobranded-regular-fonts-others.theming';
import { FoundationsKubitCobrandedRegularFontsParagraphsTheming } from './foundations-kubit-cobranded-regular-fonts-paragraphs.theming';
import { FoundationsKubitCobrandedRegularGradientsTheming } from './foundations-kubit-cobranded-regular-gradients.theming';
import { FoundationsKubitCobrandedRegularShadowsTheming } from './foundations-kubit-cobranded-regular-shadows.theming';
import { DurationsFoundationsThemes } from '../../commons/durations-foundations.themes';
import { RadiusFoundationsThemes } from '../../commons/radius-foundations.themes';
import { RegularCobrandedKubitColorsFoundationsTheming } from './regular-cobranded-kubit-colors-foundations.theming';
import { SpacingFoundationsThemes } from '../../commons/spacing-foundations.themes';
import { SizesFoundationsThemes } from '../../commons/sizes-foundations.themes';
import { SpreadFoundationsThemes } from '../../commons/spread-foundations.themes';
export { FoundationsKubitCobrandedRegularTheme };
const FoundationsKubitCobrandedRegularTheme = {
    ...AlphaFoundationsThemes,
    ...BlurFoundationsThemes,
    ...BordersFoundationsThemes,
    ...FontsLineHeightsFoundationsThemes,
    ...FontsExceptionsFoundationsThemes,
    ...FontsFamiliesFoundationsThemes,
    ...FontsSizesFoundationsThemes,
    ...FontsWeightFoundationsThemes,
    ...FoundationsKubitCobrandedRegularBlursTheming,
    ...FoundationsKubitCobrandedRegularFontsHeadingsTheming,
    ...FoundationsKubitCobrandedRegularFontsOthersTheming,
    ...FoundationsKubitCobrandedRegularFontsParagraphsTheming,
    ...FoundationsKubitCobrandedRegularGradientsTheming,
    ...FoundationsKubitCobrandedRegularShadowsTheming,
    ...DurationsFoundationsThemes,
    ...RadiusFoundationsThemes,
    ...RegularCobrandedKubitColorsFoundationsTheming,
    ...SpacingFoundationsThemes,
    ...SpreadFoundationsThemes,
    ...SizesFoundationsThemes,
};
//# sourceMappingURL=index.js.map